module.exports = __webpack_public_path__ + "img/zhongxinGH0.0950b7b5.png";